import { render, staticRenderFns } from "./SetMealList.vue?vue&type=template&id=1898604e&scoped=true&"
import script from "./SetMealList.vue?vue&type=script&lang=js&"
export * from "./SetMealList.vue?vue&type=script&lang=js&"
import style0 from "./SetMealList.vue?vue&type=style&index=0&id=1898604e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1898604e",
  null
  
)

export default component.exports